import Alert from "react-bootstrap/Alert";

export interface CannotGradeAlertProps {
  currentLocationStatus?: string;
  allowedGradingStatuses?: string[];
}

export const CannotGradeAlert = ({
  currentLocationStatus,
  allowedGradingStatuses,
}: CannotGradeAlertProps) => {
  let message = "Unknown error";
  if (!currentLocationStatus) {
    message =
      "No current stock status provided. Please retrieve the latest from the PM.";
  } else {
    message = `Cannot grade because the current stock status '${currentLocationStatus}' is not allowed for grading.`;
  }

  return (
    <Alert variant="warning" className="mb-3">
      <Alert.Heading>Cannot Grade</Alert.Heading>
      {message}
      <hr />
      Allowed Stock Statuses for grading list:
      <ul>
        {allowedGradingStatuses?.map((status) => (
          <li key={status}>{status}</li>
        ))}
      </ul>
      If you have updated the PM, please <b>Retrieve Latest from PM</b> using
      the button above. Below is a preview of the grade as it currently stands.
      <hr />
      <i>
        If you believe this is an error, please{" "}
        <a href={process.env.REACT_APP_REQUEST_SUPPORT_URL}>contact support.</a>
      </i>
    </Alert>
  );
};
